import { h, Component } from 'preact';

import { configure } from '../../../../../config';
import pageStyles from '../../../pageStyles';

import { COMMON_CONFIGS, getCommonProps } from '../../../../../lib/page';
import { trackPageLoad } from '../../../../../lib/tracking';

import Header from '@cube/header-widget';
import { Row, Section, ContainerFluid } from '@cube/layout';
import { trackingProvider, DIMENSION } from '@cube/track';
import { AboutOurAds as AboutOurAdsWidget } from '@cube/privacy-widgets';

@trackingProvider({
	[DIMENSION.componentpath]: 'AboutOurAdsPage'
})
@configure({
	...COMMON_CONFIGS,
	pageConfig: 'singleCube.pages.aboutOurAds'
})
export default class AboutOurAds extends Component {

	componentDidMount() {
		trackPageLoad(this.context);
	}

	render({ pageConfig, ...props }) {

		return (
			<ContainerFluid class={pageStyles.fluidPageNoPadding}>
				<Header
					{...props}
					{...pageConfig.header}
				/>
				<Section>
					<Row class={pageStyles.singleWidgetRow}>
						<AboutOurAdsWidget {...getCommonProps(props)} />
					</Row>
				</Section>
			</ContainerFluid>
		);
	}
}
